import { render, staticRenderFns } from "./salarydealpjxfrm.vue?vue&type=template&id=65586d18"
import script from "./salarydealpjxfrm.vue?vue&type=script&lang=js"
export * from "./salarydealpjxfrm.vue?vue&type=script&lang=js"
import style0 from "./salarydealpjxfrm.vue?vue&type=style&index=0&id=65586d18&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports